import React from "react";
import {
  ProfileMenuPage,
  FeedbackFormPage,
  FeedbackHistoryPage,
  LoyaltyRewardsPage,
  VenueVisitsPage,
} from "@zillout/shared-components";
import { getPubId } from "../config/env";

export const AccountProfileMenu: React.FC = () => {
  const pubId = getPubId();
  return <ProfileMenuPage pubId={pubId} />;
};

export const AccountFeedbackForm: React.FC = () => {
  const pubId = getPubId();
  return <FeedbackFormPage pubId={pubId} />;
};

export const AccountFeedbackHistory: React.FC = () => {
  const pubId = getPubId();
  return <FeedbackHistoryPage pubId={pubId} />;
};

export const AccountLoyaltyRewards: React.FC = () => {
  const pubId = getPubId();
  return <LoyaltyRewardsPage pubId={pubId} />;
};

export const AccountVenueVisits: React.FC = () => {
  const pubId = getPubId();
  return <VenueVisitsPage pubId={pubId} />;
};
